import { FeatureCollection } from 'geojson'
import { get } from 'lodash'
import { DEFAULT_H3_OPTIONS, get3dH3Style } from 'map-style-utils'
import { Layer, LayerProps, useMap } from 'ms-map-gl'
import { FC, useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { HexagonClickPlugin } from '~map-preview/App/Map/Plugins/FeatureClickPlugin/Hexagon'
import { useAggregateProperty } from '~map-preview/states/hexagons'
import { setLegend } from '~map-preview/states/legend'

type Hexagon3DLayerProps = {
  geojson: FeatureCollection
  resolution3D: number
}

export const Hexagon3DLayer: FC<Hexagon3DLayerProps> = (props) => {
  const { geojson, resolution3D } = props
  const dispatch = useDispatch()
  const aggregatedValue = useAggregateProperty()

  const options = useMemo(
    () => ({ ...DEFAULT_H3_OPTIONS, aggregateProperty: aggregatedValue }),
    [aggregatedValue]
  )

  const { fill, legend } = useMemo(
    () => get3dH3Style(geojson, resolution3D, options),
    [geojson, options, resolution3D]
  )

  useEffect(() => {
    legend && dispatch(setLegend(legend))
  }, [dispatch, legend])

  const interactionLayer = get(fill, 'id', undefined)

  return (
    <>
      {fill && <Layer {...(fill as LayerProps)} />}

      {interactionLayer && <HexagonClickPlugin layer={interactionLayer} />}
    </>
  )
}
